module.exports = __webpack_public_path__ + "img/battery_charging_60.f99a0ec7.svg";